const goodsUpdate = () => import('@/views/main/goods/update/update.vue')
export default {
  path: '/main/goods/update',
  name: 'goodsUpdate',
  component: goodsUpdate,
  children: []
}
